import axios from 'axios'
import { Message } from 'element-ui'
// import store from '@/store'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 50000 // request timeout
})
// 请求拦截器
service.interceptors.request.use(
  config => {
    // config.headers['Authorization'] = 'dsadsacadajhfvjhakj'
    config.headers['appId'] = '62245763-6c60-11f0-8e75-fa163e6ac2d0'
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service